var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal"}],staticClass:"m-l-15",attrs:{"size":"sm","variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.exportarExcel.apply(null, arguments)}}},[_c('i',{staticClass:"icon-upload"}),_vm._v(" Ex excel ")])
}
var staticRenderFns = []

export { render, staticRenderFns }